export default __webpack_public_path__ + "static/media/1G.0fb8729c.png";